export type TipoItemCodigo = 'SERCOM' | 'MEDIC' | 'MATERI';

export interface TipoItemOption {
  value: TipoItemCodigo;
  label: string;
}

export const TIPO_ITEM_OPTIONS: TipoItemOption[] = [
  { value: 'SERCOM', label: 'PROCEDIMENTO' },
  { value: 'MEDIC', label: 'MEDICAMENTO' },
  { value: 'MATERI', label: 'MATERIAL' },
];

const TIPO_ITEM_LABELS: Record<TipoItemCodigo, string> = {
  SERCOM: 'PROCEDIMENTO',
  MEDIC: 'MEDICAMENTO',
  MATERI: 'MATERIAL',
};

export const isTipoItemCodigo = (value: string): value is TipoItemCodigo =>
  TIPO_ITEM_OPTIONS.some((option) => option.value === value);

export const formatTipoItemLabel = (tipoProdMed?: string | null): string => {
  if (!tipoProdMed?.trim()) return '—';

  const codigo = tipoProdMed.trim().toUpperCase();
  if (isTipoItemCodigo(codigo)) {
    return TIPO_ITEM_LABELS[codigo];
  }

  return tipoProdMed.trim();
};

export const normalizeTipoItemCodigo = (tipoProdMed?: string | null): TipoItemCodigo | '' => {
  if (!tipoProdMed?.trim()) return '';

  const codigo = tipoProdMed.trim().toUpperCase();
  return isTipoItemCodigo(codigo) ? codigo : '';
};
